import React, { useState, useRef, useEffect } from "react";
import "./Hero2.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Hero2 = () => {
    const slides = [
        {
          id: 1,
          image: "https://images.pexels.com/photos/2102416/pexels-photo-2102416.jpeg?auto=compress&cs=tinysrgb&w=600", 
          alt: "Business Strategy",
          title: "High-Quality Printing",
          description:
            "Experience top-notch printing services that bring your ideas to life. From business cards to custom branding materials, we’ve got you covered.",
        },
        {
          id: 2,
          image: "https://images.pexels.com/photos/2351844/pexels-photo-2351844.jpeg?auto=compress&cs=tinysrgb&w=600", 
          alt: "Tailored Solutions",
          title: "Tailored Solutions",
          description: "Providing customized solutions that cater to your unique business needs and goals.",
        },
        {
          id: 3,
          image: "https://images.pexels.com/photos/7862600/pexels-photo-7862600.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
          alt: "Team Empowerment",
          title: "Team Empowerment",
          description: "Boost your team’s performance with our professional training and resources.",
        },
        {
          id: 4,
          image: "https://images.pexels.com/photos/9558702/pexels-photo-9558702.jpeg?auto=compress&cs=tinysrgb&w=300",
          alt: "Growth Acceleration",
          title: "Growth Acceleration",
          description: "Accelerate your business growth with innovative approaches and sustainable strategies.",
        },
        {
          id: 5,
          image: "/images/hero-image5.png", 
          alt: "Client-Centered Service",
          title: "Client-Centered Service",
          description: "At Adcore Consults, we focus on delivering maximum satisfaction through personalized attention.",
        },
      ];
      

  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  // Start auto-scrolling
  useEffect(() => {
    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
      }, 8000); // 8 seconds
    };

    startAutoScroll();

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, [slides.length]);

  // Manual Navigation
  const handlePrev = () => {
    clearInterval(intervalRef.current); // Stop auto-scroll
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const handleNext = () => {
    clearInterval(intervalRef.current); // Stop auto-scroll
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  return (
    <div className="carousel-container">
      <div className="carousel">
        <div
          className="carousel-inner"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
            transition: "transform 0.5s ease-in-out",
          }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="carousel-item">
              <img src={slide.image} className="d-block w-100" alt={slide.alt} />
              <div className="carousel-overlay">
                <h2 className="carousel-title" data-aos="fade-down">{slide.title}</h2>
                <p className="carousel-description" data-aos="fade-up">{slide.description}</p>
              </div>
            </div>
          ))}
        </div>
        <button className="carousel-control-prev" onClick={handlePrev}>
          <IoIosArrowBack />
        </button>
        <button className="carousel-control-next" onClick={handleNext}>
          <IoIosArrowForward />
        </button>
      </div>
    </div>
  );
};

export default Hero2;
